import { render, staticRenderFns } from "./ProposalTasksRouterView.vue?vue&type=template&id=42dc90ef&"
import script from "./ProposalTasksRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalTasksRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports